// tslint:disable
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url'
import { Configuration } from './configuration'
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base'

/**
 *
 * @export
 * @interface AuthResponse
 */
export interface AuthResponse {
  /**
   *
   * @type {string}
   * @memberof AuthResponse
   */
  userId?: string
  /**
   *
   * @type {string}
   * @memberof AuthResponse
   */
  bankUserId?: string
  /**
   *
   * @type {string}
   * @memberof AuthResponse
   */
  walletIdentificationLevel?: string
  /**
   *
   * @type {string}
   * @memberof AuthResponse
   */
  msisdn?: string
  /**
   *
   * @type {number}
   * @memberof AuthResponse
   */
  region?: number
  /**
   *
   * @type {string}
   * @memberof AuthResponse
   */
  regionCode?: string
  /**
   *
   * @type {string}
   * @memberof AuthResponse
   */
  operator?: string
  /**
   *
   * @type {boolean}
   * @memberof AuthResponse
   */
  bonusForOperation?: boolean
  /**
   *
   * @type {boolean}
   * @memberof AuthResponse
   */
  canIdentification?: boolean
  /**
   *
   * @type {string}
   * @memberof AuthResponse
   */
  profileName?: string
  /**
   *
   * @type {string}
   * @memberof AuthResponse
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof AuthResponse
   */
  surname?: string
  /**
   *
   * @type {string}
   * @memberof AuthResponse
   */
  patronymic?: string
  /**
   *
   * @type {string}
   * @memberof AuthResponse
   */
  userToken?: string
  /**
   *
   * @type {string}
   * @memberof AuthResponse
   */
  syncResult?: string
  /**
   *
   * @type {AuthResponseError}
   * @memberof AuthResponse
   */
  error?: AuthResponseError
}
/**
 *
 * @export
 * @interface AuthResponseError
 */
export interface AuthResponseError {
  /**
   *
   * @type {number}
   * @memberof AuthResponseError
   */
  code?: number
  /**
   *
   * @type {string}
   * @memberof AuthResponseError
   */
  title?: string
  /**
   *
   * @type {string}
   * @memberof AuthResponseError
   */
  uuid?: string
  /**
   *
   * @type {string}
   * @memberof AuthResponseError
   */
  details?: string
}
/**
 *
 * @export
 * @interface BalanceLimit
 */
export interface BalanceLimit {
  /**
   *
   * @type {string}
   * @memberof BalanceLimit
   */
  amount?: string
  /**
   *
   * @type {string}
   * @memberof BalanceLimit
   */
  currency?: string
}
/**
 *
 * @export
 * @interface Binding
 */
export interface Binding {
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  bindingId?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  mnemonic?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  createdDate?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  updatedDate?: string
  /**
   *
   * @type {boolean}
   * @memberof Binding
   */
  isDefaultBinding?: boolean
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  bindingType?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  bindingStatus?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  balance?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  currency?: string
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof Binding
   */
  bindingParams?: { [key: string]: string }
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  minAmount?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  maxAmount?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  cardId?: string
  /**
   *
   * @type {LimitsInfo}
   * @memberof Binding
   */
  limitsInfo?: LimitsInfo
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  phoneNumber?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  userId?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  maskedPhoneNumber?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  maskedPan?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  expiry?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  expiresInLessThan?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  cardType?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  cardStatus?: string
  /**
   *
   * @type {boolean}
   * @memberof Binding
   */
  is3DSecureBinding?: boolean
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  bankStatus?: string
  /**
   *
   * @type {Array<string>}
   * @memberof Binding
   */
  tokenization_system?: Array<string>
}
/**
 *
 * @export
 * @interface BindingRq
 */
export interface BindingRq {
  /**
   *
   * @type {string}
   * @memberof BindingRq
   */
  walletId?: string
  /**
   *
   * @type {string}
   * @memberof BindingRq
   */
  phone?: string
  /**
   *
   * @type {string}
   * @memberof BindingRq
   */
  bindingStatus?: string
  /**
   *
   * @type {string}
   * @memberof BindingRq
   */
  bindingParams?: string
  /**
   *
   * @type {boolean}
   * @memberof BindingRq
   */
  includeBankAccount?: boolean
  /**
   *
   * @type {boolean}
   * @memberof BindingRq
   */
  includeTokenCard?: boolean
}
/**
 *
 * @export
 * @interface BindingRs
 */
export interface BindingRs {
  /**
   *
   * @type {string}
   * @memberof BindingRs
   */
  userId?: string
  /**
   *
   * @type {Array<Binding>}
   * @memberof BindingRs
   */
  bindings?: Array<Binding>
  /**
   *
   * @type {ErrorRs}
   * @memberof BindingRs
   */
  error?: ErrorRs
}
/**
 *
 * @export
 * @interface ErrorRs
 */
export interface ErrorRs {
  /**
   *
   * @type {number}
   * @memberof ErrorRs
   */
  code?: number
  /**
   *
   * @type {string}
   * @memberof ErrorRs
   */
  title?: string
  /**
   *
   * @type {string}
   * @memberof ErrorRs
   */
  uuid?: string
  /**
   *
   * @type {string}
   * @memberof ErrorRs
   */
  details?: string
}
/**
 *
 * @export
 * @interface LimitsInfo
 */
export interface LimitsInfo {
  /**
   *
   * @type {BalanceLimit}
   * @memberof LimitsInfo
   */
  balanceLimit?: BalanceLimit
}
/**
 *
 * @export
 * @interface TokenizationCardDataRs
 */
export interface TokenizationCardDataRs {
  /**
   *
   * @type {string}
   * @memberof TokenizationCardDataRs
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof TokenizationCardDataRs
   */
  encryptedCardData?: string
  /**
   *
   * @type {ErrorRs}
   * @memberof TokenizationCardDataRs
   */
  error?: ErrorRs
}
/**
 *
 * @export
 * @interface WalletRq
 */
export interface WalletRq {
  /**
   *
   * @type {string}
   * @memberof WalletRq
   */
  phone?: string
}
/**
 *
 * @export
 * @interface WalletRs
 */
export interface WalletRs {
  /**
   *
   * @type {string}
   * @memberof WalletRs
   */
  userId?: string
  /**
   *
   * @type {string}
   * @memberof WalletRs
   */
  walletIdentificationLevel?: string
  /**
   *
   * @type {string}
   * @memberof WalletRs
   */
  status?: string
  /**
   *
   * @type {string}
   * @memberof WalletRs
   */
  phone?: string
  /**
   *
   * @type {string}
   * @memberof WalletRs
   */
  createdDate?: string
  /**
   *
   * @type {string}
   * @memberof WalletRs
   */
  bankUserId?: string
  /**
   *
   * @type {ErrorRs}
   * @memberof WalletRs
   */
  error?: ErrorRs
}

/**
 * ControllerApi - axios parameter creator
 * @export
 */
export const ControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ewalletAuth(body?: object, options: any = {}): RequestArgs {
      const localVarPath = `/ewallet-profile/api/v1/auth`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof body !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : body || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {BindingRq} [bindingRq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBindings(bindingRq?: BindingRq, options: any = {}): RequestArgs {
      const localVarPath = `/ewallet-profile/api/v1/getBindings`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof bindingRq !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(bindingRq !== undefined ? bindingRq : {})
        : bindingRq || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCardDataForTokenization(options: any = {}): RequestArgs {
      const localVarPath = `/ewallet-profile/api/v1/getCardDataForTokenization`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {WalletRq} [walletRq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWallet(walletRq?: WalletRq, options: any = {}): RequestArgs {
      const localVarPath = `/ewallet-profile/api/v1/getWallet`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof walletRq !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(walletRq !== undefined ? walletRq : {})
        : walletRq || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ControllerApi - functional programming interface
 * @export
 */
export const ControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ewalletAuth(
      body?: object,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse> {
      const localVarAxiosArgs = ControllerApiAxiosParamCreator(configuration).ewalletAuth(body, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @param {BindingRq} [bindingRq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBindings(
      bindingRq?: BindingRq,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BindingRs> {
      const localVarAxiosArgs = ControllerApiAxiosParamCreator(configuration).getBindings(bindingRq, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCardDataForTokenization(
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenizationCardDataRs> {
      const localVarAxiosArgs = ControllerApiAxiosParamCreator(configuration).getCardDataForTokenization(options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @param {WalletRq} [walletRq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWallet(
      walletRq?: WalletRq,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WalletRs> {
      const localVarAxiosArgs = ControllerApiAxiosParamCreator(configuration).getWallet(walletRq, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ControllerApi - factory interface
 * @export
 */
export const ControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  return {
    /**
     *
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ewalletAuth(body?: object, options?: any): AxiosPromise<AuthResponse> {
      return ControllerApiFp(configuration).ewalletAuth(body, options)(axios, basePath)
    },
    /**
     *
     * @param {BindingRq} [bindingRq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBindings(bindingRq?: BindingRq, options?: any): AxiosPromise<BindingRs> {
      return ControllerApiFp(configuration).getBindings(bindingRq, options)(axios, basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCardDataForTokenization(options?: any): AxiosPromise<TokenizationCardDataRs> {
      return ControllerApiFp(configuration).getCardDataForTokenization(options)(axios, basePath)
    },
    /**
     *
     * @param {WalletRq} [walletRq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWallet(walletRq?: WalletRq, options?: any): AxiosPromise<WalletRs> {
      return ControllerApiFp(configuration).getWallet(walletRq, options)(axios, basePath)
    },
  }
}

/**
 * ControllerApi - object-oriented interface
 * @export
 * @class ControllerApi
 * @extends {BaseAPI}
 */
export class ControllerApi extends BaseAPI {
  /**
   *
   * @param {object} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ControllerApi
   */
  public ewalletAuth(body?: object, options?: any) {
    return ControllerApiFp(this.configuration).ewalletAuth(body, options)(this.axios, this.basePath)
  }

  /**
   *
   * @param {BindingRq} [bindingRq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ControllerApi
   */
  public getBindings(bindingRq?: BindingRq, options?: any) {
    return ControllerApiFp(this.configuration).getBindings(bindingRq, options)(this.axios, this.basePath)
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ControllerApi
   */
  public getCardDataForTokenization(options?: any) {
    return ControllerApiFp(this.configuration).getCardDataForTokenization(options)(this.axios, this.basePath)
  }

  /**
   *
   * @param {WalletRq} [walletRq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ControllerApi
   */
  public getWallet(walletRq?: WalletRq, options?: any) {
    return ControllerApiFp(this.configuration).getWallet(walletRq, options)(this.axios, this.basePath)
  }
}
